<template>
	<div class="create-guest-comp">
		<form @submit.prevent="submit">
			<h3>Aggiugi ospite</h3>

			<div class="field-grid">
				<div class="field">
					<input type="text" v-model="firstName" name="first-name" autocomplete="off"/>
					<label>Nome</label>
				</div>

				<div class="field">
					<input type="text" v-model="lastName" name="last-name" autocomplete="off" required/>
					<label>Cognome</label>
				</div>
			</div>

			<div class="field">
				<button>Registra</button>
			</div>
		</form>
	</div>
</template>

<script>
export default {
	name: "create-guest-dialog",

	data() {

		return {
			firstName: "",
			lastName: ""
		}
	},

	methods: {
		submit() {

			this.$emit("sub", {firstName: this.firstName, lastName: this.lastName})
		}
	}
}
</script>

<style lang="stylus" scoped>
.field-grid
	display grid
	grid-gap 0.5em
	grid-template-columns repeat(2, 1fr)

.field
	margin 0.4em 0

	>input
		input()

		width 100%

		background-color darkish
		color light

		font-size 1.1em

		&:read-only
			color mix(darkish, lightish)
		&:focus
			outline-color primary

	>label
		display block

		margin-top 0.2em

		color primary

		font-family fontSans
		font-size 0.8em

	>button
		border none
		padding 0.4em 0.6em

		background-color primary
		color dark

		font-family fontSans
		font-size 1em
		font-weight bold

		text-transform uppercase

		cursor pointer
</style>
